export default __webpack_public_path__ + "static/media/juan vargas.943714d7.jpg";